import { Tooltip, Whisper } from 'rsuite';
import { BROKEN_LIMIT_WARNING_TEXT, BrokenLimitWarning } from '../../utils/brokenLimitWarningUtils';
import { MdReport } from '../QuickActionFilter/elements/Icon/assets';
import styles from './BrokenLimitWarningIcon.module.scss';

type BrokenLimitWarningIconProps = {
  warning: BrokenLimitWarning | null;
};

const BrokenLimitWarningIcon = ({ warning }: BrokenLimitWarningIconProps) => {
  if (!warning) return null;

  const text = BROKEN_LIMIT_WARNING_TEXT[warning];

  return (
    <Whisper trigger={['hover', 'focus']} placement="bottomEnd" speaker={<Tooltip className={styles.tooltip}>{text}</Tooltip>}>
      <span className={styles.warningIcon} role="img" aria-label={text} tabIndex={0}>
        <MdReport width={12} height={12} aria-hidden />
      </span>
    </Whisper>
  );
};

export default BrokenLimitWarningIcon;
